import { NztcsSpeciesEntity } from '../../domain/nztcs/nztcs-species-entity';
import { Type } from '@angular/core';

export class SpeciesSourceItem {
  constructor(
    public component: Type<any>,
    public nztcsSpecies: NztcsSpeciesEntity
  ) {}
}
